<script lang="ts">
import { Hamburger } from 'svelte-hamburgers';
import { isMenuOpen } from '../../../utils/store.js';

interface Props {
    open?: boolean;
    burgerColour?: string;
}

let { open = $bindable(false), burgerColour = 'var(--colour-white)' }: Props = $props();

isMenuOpen.subscribe((value) => {
    open = value;
});

$effect(() => {
    isMenuOpen.set(open);
});
</script>

<div class="menu-trigger">
    <Hamburger
        bind:open
        --padding="0"
        --layer-height="1px"
        --layer-width="22px"
        --layer-spacing="4px"
        --color={burgerColour}
        --active-color="var(--colour-dreamless-sleep)"
    />
    <span>Menu</span>
</div>

<style lang="scss">
    @use '/src/scss/global-constants/mq-config';
    @use 'sass-mq/mq' as *;

    .menu-trigger {
        align-items: center;
        background: transparent;
        border: 0;
        cursor: pointer;
        display: flex;
        margin: 0;
        outline: 0;
        padding: 0;

        @include mq($from: tablet) {
            display: none;
        }
    }

    span {
        display: none;
        text-transform: uppercase;

        @include mq($from: tablet) {
            display: block;
        }
    }
</style>
